const fetchMoreEvent = uid => {
  return `DataFetch:fetchMore:${uid}`;
};

export default {
  fetchMoreEvent,
};
